import * as React from 'react';
import {
  isObject,
  isArray,
  isString,
  isNumber,
  isFunction,
  isEmpty,
  isEqual,
  uniq,
} from 'lodash';
import {
  globalElements,
  execAtaComponent,
  registerAtaComponents,
} from './glob';
import { genId } from './common/util';
import { filterProperties } from './common/filterProperties';

export interface ItemProps {
  title?: string | number | React.ReactNode | ItemProps[];
  body?: Array<React.ReactNode | ItemProps>;
  footer?: Array<React.ReactNode | ItemProps>;
  dot?: Array<React.ReactNode | ItemProps>;
  attr?: object;
  itemClass?: string;
  itemStyle?: string | object;
  uniqId?: string;
  directChildType?: string; // 直接子节点
  directChildIndex?: number; // 直接子节点下标，指 body footer dot title的数组项下标
  methods?: object;
  img?: string | object | Array<React.ReactNode>;
  url?: string | { href?: string; target?: string };

  // 子容器属性
  titleClass?: string;
  titleStyle?: object;
  titleBox?: object;
  bodyClass?: string;
  bodyStyle?: object;
  bodyBox?: object;
  footerClass?: string;
  footerStyle?: object;
  footerBox?: object;

  [propName: string]: any; // react的事件体系, 其他属性  @item @list
}

function comonPart(target: any, type: string): any {
  let subItemClassName = 'titles-sub-item';
  if (type === 'body') {
    subItemClassName = 'body-sub-item';
  }
  if (type === 'footer') {
    subItemClassName = 'footer-sub-item';
  }
  if (type === 'dot') {
    subItemClassName = 'dot-sub-item';
  }

  return (
    <React.Fragment>
      {target.map((subItem: any, ii: number) => {
        const uniqId = this.uniqId + '.' + genId(8);
        const oriClassName = subItem.itemClass || subItem?.props?.className;
        const cls = oriClassName
          ? subItemClassName + ' ' + oriClassName
          : subItemClassName;

        if (React.isValidElement(subItem)) {
          const { events } = filterProperties(subItem.props, this.uniqId);
          return React.cloneElement(subItem, { ...events, className: cls });
        }

        if (isString(subItem) || isNumber(subItem)) {
          subItem = { title: subItem };
        }

        return (
          <Item
            key={uniqId}
            {...subItem}
            itemClass={cls}
            uniqId={uniqId}
            directChildType={type}
            directChildIndex={ii}
          />
        );
      })}
    </React.Fragment>
  );
}

// item.title
function ItemTitle(props: {
  title: React.ReactNode | ItemProps;
  itemProperties: any;
  context?: any;
}): any {
  const { itemProperties, context } = props;
  let { titleClass, titleStyle, titleBox } = itemProperties;
  const boxProperties = {
    ...titleBox,
    className: titleClass ? 'hitem-titles ' + titleClass : 'hitem-titles',
    style: titleStyle,
  };
  let target: any = props.title;
  let JSX = null;

  if (React.isValidElement(target)) {
    const { events } = filterProperties(target.props, context.uniqId);
    JSX = React.useMemo(() => {
      let cls = target.props.className || 'hitem-title';
      if (cls.indexOf('hitem-title') === -1) {
        cls = 'hitem-title ' + target.props.className;
      }
      return React.cloneElement(target, { ...events, className: cls });
    }, [target]);
  }

  if (isString(target) || isNumber(target)) {
    JSX = <span className="hitem-title">{target}</span>;
  }

  if (isObject(target) && !React.isValidElement(target)) {
    JSX = <Item {...target} />;
  }

  // if (url) {
  //   if (isString(url)) {
  //     if (url.indexOf('__ ') === 0) {
  //       url = { href: url.replace('__ ', ''), target: '__blank' };
  //     } else {
  //       JSX = <a href={url}>{JSX}</a>;
  //     }
  //   }

  //   if (isObject(url)) {
  //     const { href, target } = url as { href?: string; target?: string };
  //     JSX = (
  //       <a href={href} target={target}>
  //         {JSX}
  //       </a>
  //     );
  //   }
  // }

  if (isArray(target)) {
    JSX = (
      <div {...boxProperties}>{comonPart.call(context, target, 'title')}</div>
    );
  }

  return JSX;
}

// item.body
function ItemBody(props: {
  body: Array<React.ReactNode | ItemProps>;
  itemProperties: any;
  context?: any;
}): any {
  const { itemProperties, context } = props;
  const { bodyClass, bodyStyle, bodyBox } = itemProperties;
  const boxProperties = {
    ...bodyBox,
    className: bodyClass ? 'hitem-body ' + bodyClass : 'hitem-body',
    style: bodyStyle,
  };
  let target: any = props.body;
  let JSX = null;

  if (isArray(target)) {
    JSX = (
      <div {...boxProperties}>{comonPart.call(context, target, 'body')}</div>
    );
  }
  return JSX;
  // return React.useMemo(() => JSX, [props.body]);
}

// item.footer
function ItemFooter(props: {
  footer: Array<React.ReactNode | ItemProps>;
  itemProperties: any;
  context?: any;
}): any {
  const { itemProperties, context } = props;
  const { footerClass, footerStyle, footerBox } = itemProperties;
  const boxProperties = {
    ...footerBox,
    className: footerClass ? 'hitem-footer ' + footerClass : 'hitem-footer',
    style: footerStyle,
  };
  let target: any = props.footer;
  let JSX = null;

  if (isArray(target)) {
    JSX = (
      <div {...boxProperties}>{comonPart.call(context, target, 'footer')}</div>
    );
  }
  return JSX;
  // return React.useMemo(() => JSX, [props.footer]);
}

// item.dot
function ItemDot(props: {
  dot: Array<React.ReactNode | ItemProps>;
  itemProperties: any;
  context?: any;
}): any {
  let target: any = props.dot;
  let JSX = null;

  if (isArray(target)) {
    JSX = comonPart.call(props.context, target, 'dot');
  }
  return JSX;
  // return React.useMemo(() => JSX, [props.dot]);
}

function getDirectChilds(childs: any, uniqId: string) {
  const directChild: any = {};
  if (childs.length) {
    for (let id in childs) {
      if (id !== 'length') {
        if (id.length - uniqId.length === 9) {
          directChild[id] = childs[id];
        }
      }
    }
  }
  return directChild;
}

function adapterProps(props: any, uniqId: string) {
  const data = {
    ...props,
    created: null,
    attached: null,
    ready: null,
    detached: null,
    moved: null,
    attr: null,
  };
  delete data.created;
  delete data.attached;
  delete data.ready;
  delete data.detached;
  delete data.moved;
  delete data.attr;
  const { title, body, footer, dot } = data;

  function parseItem(item) {
    if (isString(item) || isNumber(item) || React.isValidElement(item)) {
      return { title: item };
    }
    return item;
  }

  if (isArray(title)) {
    data.title = title.map((item) => parseItem(item));
  }
  if (body) {
    data.body = body.map((item) => parseItem(item));
  }
  if (footer) {
    data.footer = footer.map((item) => parseItem(item));
  }
  if (dot) {
    data.dot = dot.map((item) => parseItem(item));
  }
  return data;
}

type PropsWithChildren<P> = P & { children?: React.ReactNode };
type HyperProps = PropsWithChildren<{
  url: string | { href?: string; target?: string };
}>;

const HyperlinkWrap: React.FC<HyperProps> = (props) => {
  let { url, children } = props;
  let JSX: any = children;
  if (url) {
    if (isString(url)) {
      if (url.indexOf('__ ') === 0) {
        (url as any) = { href: url.replace('__ ', ''), target: '__blank' };
      } else {
        JSX = <a href={url}>{JSX}</a>;
      }
    }

    if (isObject(url)) {
      const { href, target } = url as { href?: string; target?: string };
      JSX = (
        <a href={href} target={target}>
          {JSX}
        </a>
      );
    }
  }
  return JSX;
};

export const Item: React.FC = React.forwardRef(
  (props: ItemProps, ref: any): React.ReactElement => {
    const id = props.id || props['$$id'];
    const uniqIdRef = React.useRef(props.uniqId || genId(8));
    const createdRef = React.useRef(false); // 生命周期 created
    const uniqId = uniqIdRef.current;
    const { events, notEvents, lifeTimes, attr, innerComponents } =
      filterProperties({...props}, uniqId);
    const propsRef = React.useRef(adapterProps(props, uniqId));
    const oriPropsRef = React.useRef({ ...propsRef.current });
    const domRef = React.useRef(null);
    const [state, setState] = React.useState({ ...propsRef.current });

    const [innerCmpts] = React.useState<object>(innerComponents);
    const [loading, setLoading] = React.useState<boolean>(false);
    const [disabled, setDisabled] = React.useState<boolean>(false);
    const [showState, setShowState] = React.useState(true);
    const [className, setClassName] = React.useState(
      propsRef.current.itemClass
    );
    // const data = propsRef.current;
    // let cls = 'ui-item';
    // if (data.itemClass) {
    //   if (data.itemClass.indexOf('ui-item') === -1) {
    //     cls = 'ui-item ' + data.itemClass;
    //   } else {
    //     cls = data.itemClass;
    //   }
    // }
    // data.itemClass = cls;
    // propsRef.current = data;

    function setMyState(param: any = {}) {
      const oldState = { ...state };
      const { title, body, footer, dot } = param;
      let isArrayTitles = false;
      let isArrayBody = false;
      let isArrayFooter = false;
      let isArrayDot = false;
      if (isArray(title)) {
        isArrayTitles = true;
        oldState.title = [];
      }
      if (isArray(body)) {
        isArrayBody = true;
        oldState.body = [];
      }
      if (isArray(footer)) {
        isArrayFooter = true;
        oldState.footer = [];
      }
      if (isArray(dot)) {
        isArrayDot = true;
        oldState.dot = [];
      }
      propsRef.current = { ...oldState, ...param };
      if (isArrayTitles || isArrayBody || isArrayFooter || isArrayDot) {
        // const attached = lifeTimes.attached;
        // lifeTimes.attached = function () {
        //   setState({ ...oldState, ...param });
        //   attached.call(this);
        // }.bind(context);
        // setState({ ...oldState });
        // console.log('========', {...oldState, ...param});
        setState({ ...oldState, ...param });
      } else {
        setState({ ...oldState, ...param });
      }
    }

    const context = {
      is: 'item',
      uniqId,
      directChildType: props.directChildType || 'self',
      directChildIndex:
        props.directChildIndex >= 0 ? props.directChildIndex : -1,
      getData(unit?: string) {
        const childs = this.children();
        const data = propsRef.current;
        if (unit === 'itemClass') {
          return data.itemClass;
        }
        if (unit === 'itemStyle') {
          return data.itemStyle;
        }
        if (childs.length) {
          const directChild: any = getDirectChilds(childs, uniqId);
          for (let id in directChild) {
            const ctx = directChild[id];
            const { directChildType, directChildIndex } = ctx;
            if (directChildIndex > -1) {
              let oldData = data[directChildType][directChildIndex];
              const childData = ctx.getData();
              if (
                isString(oldData) ||
                isNumber(oldData) ||
                React.isValidElement(oldData)
              ) {
                oldData = { title: oldData };
              }
              data[directChildType][directChildIndex] = {
                ...oldData,
                ...childData,
              };
            }
          }
          propsRef.current = data;
        }
        if (unit && propsRef.current[unit]) {
          return propsRef.current[unit];
        }
        return propsRef.current;
      },
      reset(param: object = {}) {
        setMyState({ ...oriPropsRef.current, ...param });
      },
      clone(param?: object) {
        const parent = this.parent();
        if (parent) {
          if (parent.is === 'item') {
            const data = parent.getData()[this.directChildType];
            const uid = parent.uniqId + '.' + genId(8);
            const cloneData = { ...this.getData(), uniqId: uid, ...param };
            data.splice(this.directChildIndex + 1, 0, cloneData);
            parent.update({
              [this.directChildType]: data,
            });
          }
          if (parent.is === 'list') {
            const data = parent.getData();
            const uid = parent.uniqId + '.' + genId(8);
            const cloneData = { ...this.getData(), uniqId: uid, ...param };
            data.splice(this.directChildIndex + 1, 0, cloneData);
            parent.update(data);
          }
        }
      },
      remove() {
        const parent = this.parent();
        if (parent) {
          if (parent.is === 'item') {
            const data = parent.getData()[this.directChildType];
            data.splice(this.directChildIndex, 1);
            parent.update({ [this.directChildType]: data });
          }
          if (parent.is === 'list') {
            const data = parent.getData();
            data.splice(this.directChildIndex, 1);
            parent.update(data);
          }
        }
      },
      show() {
        setShowState(true);
      },
      hide() {
        setShowState(false);
      },
      loading(state: boolean) {
        setLoading(state);
      },
      disable(state: boolean) {
        setDisabled(state);
      },
      update(param: any = {}) {
        const newState = { ...state, ...param };
        setMyState(newState);
      },
      addClass(clsName, cb) {
        clsName = clsName.replace('.', '');
        if (!this.hasClass(clsName)) {
          const data = propsRef.current;
          const newClassName = data.itemClass
            ? data.itemClass + ' ' + clsName
            : clsName;
          data.itemClass = newClassName;
          propsRef.current = data;
          setClassName(newClassName);
        }
        if (isFunction(cb)) {
          cb();
        }
      },
      removeClass(clsName, cb) {
        clsName = clsName.replace('.', '');
        if (this.hasClass(clsName)) {
          const re = new RegExp(`${clsName} *`, 'g');
          const data = propsRef.current;
          const newClassName = (data.itemClass || '').replace(re, '').trim();
          data.itemClass = newClassName;
          propsRef.current = data;
          setClassName(newClassName);
        }
        if (isFunction(cb)) {
          cb();
        }
      },
      hasClass(clsName) {
        clsName = clsName.replace('.', '');
        const data = propsRef.current;
        const clsArray = (data.itemClass || '').split(' ');
        if (clsArray.indexOf(clsName) > -1) {
          return true;
        }
      },
      toggleClass(cls, cb) {
        if (this.hasClass(cls)) {
          this.removeClass(cls, cb);
        } else {
          this.addClass(cls, cb);
        }
      },
      css(itemSty: object = {}, cb) {
        setMyState({ itemStyle: itemSty });
        if (isFunction(cb)) {
          cb();
        }
      },
      find(param: string) {
        // id
        // className
        let id = '';
        let cls = '';
        let result = {};
        const childs = this.children();
        const len = childs.length;
        delete childs.length;

        if (param.indexOf('#') === 0) {
          id = param.replace('#', '');
        } else {
          cls = param.replace('.', '');
        }

        if (id) {
          return globalElements[id];
        }

        if (cls) {
          for (let id in childs) {
            const child = childs[id];
            if (child.hasClass(cls)) {
              result[id] = child;
            }
          }

          function eachDo(action: string, param: any, cb?: Function) {
            for (let id in result) {
              const child = result[id];
              child[action](param);
            }
          }

          return {
            length: Object.keys(result).length,
            forEach(callback: Function) {
              let ii = 0;
              for (let id in result) {
                const child = result[id];
                callback(child, ii);
                ii++;
              }
            },
            addClass(cls: string) {
              eachDo('addClass', cls);
            },
            removeClass(cls: string) {
              eachDo('removeClass', cls);
            },
            css(sty: object) {
              eachDo('css', sty);
            },
            show() {
              eachDo('show', true);
            },
            hide() {
              eachDo('hide', false);
            },
          };
        }
      },
      parent(cls?: string) {
        const parentUid = uniqId.substr(0, uniqId.lastIndexOf('.'));
        if (parentUid) {
          const parentInstance = globalElements[parentUid];
          if (cls && parentInstance) {
            if (parentInstance.hasClass(cls)) {
              return parentInstance;
            } else {
              return parentInstance.parent(cls);
            }
          } else {
            return parentInstance;
          }
        }
      },
      siblings(cls?: string) {
        const parentNode = this.parent();
        if (parentNode) {
          const childs = parentNode.children() || {};
          const directChilds: any =
            getDirectChilds(childs, parentNode.uniqId) || {};

          let bro = {};
          for (let id in directChilds) {
            const child = directChilds[id];
            if (cls) {
              if (child.hasClass(cls)) {
                bro[id] = child;
              }
            } else {
              if (
                id !== uniqId &&
                child.directChildType === this.directChildType
              ) {
                bro[id] = child;
              }
            }
          }

          function eachDo(action: string, param: any, cb?: Function) {
            for (let id in bro) {
              const child = bro[id];
              child[action](param);
            }
          }

          return {
            length: Object.keys(bro).length,
            addClass(cls: string) {
              eachDo('addClass', cls);
            },
            removeClass(cls: string) {
              eachDo('removeClass', cls);
            },
            css(sty: object) {
              eachDo('css', sty);
            },
            show() {
              eachDo('show', true);
            },
            hide() {
              eachDo('hide', false);
            },
            forEach(callback: Function) {
              let ii = 0;
              for (let id in bro) {
                const child = bro[id];
                callback(child, ii);
                ii++;
              }
            },
          };
        }
      },

      children(cls?: string) {
        const childTypes = ['body', 'footer', 'dot', 'title'];
        const ids = Object.keys(globalElements);
        let childType = '';
        let childs: any = {};
        if (childTypes.indexOf(cls) > -1) {
          childType = cls;
          cls = '';
        }

        ids.forEach((id: string) => {
          if (id.indexOf(uniqId) === 0 && id.length > uniqId.length) {
            childs[id] = globalElements[id];
          }
        });
        childs.length = Object.keys(childs).length;

        if (cls) {
          if (cls.indexOf('>') === 0) {
            childs = getDirectChilds(childs, uniqId) || {};
            cls = cls.replace('>', '').trim();
          }
          if (cls) {
            childs = (() => {
              const tmp = {};
              for (let id in childs) {
                if (id !== 'length') {
                  const child = childs[id];
                  if (child.hasClass(cls)) {
                    tmp[id] = child;
                  }
                }
              }
              return tmp;
            })();
          }
        }

        if (childType) {
          childs = (() => {
            const tmp = {};
            for (let id in childs) {
              const child = childs[id];
              if (child.directChildType === childType) {
                tmp[id] = child;
              }
            }
            return tmp;
          })();
        }

        childs.length = Object.keys(childs).length;
        return childs;
      },
      ...props.methods,
    };

    if (isFunction(lifeTimes.created)) {
      if (createdRef.current === false) {
        createdRef.current = true;
        lifeTimes.created.call(context);
      }
    }

    React.useEffect(() => {
      if (isFunction(lifeTimes.attached)) {
        lifeTimes.attached.call(context);
      }
    });

    React.useEffect(() => {
      if (uniqId && !globalElements[uniqId]) {
        globalElements[uniqId] = context;
      }
      if (id && !globalElements[id]) {
        globalElements[id] = context;
      }
      if (isFunction(lifeTimes.ready)) {
        lifeTimes.ready.call(context);
      }
      return () => {
        globalElements[context.uniqId] = null;
        globalElements[id] = null;
        delete globalElements[context.uniqId];
        delete globalElements[id];
        if (isFunction(lifeTimes.detached)) {
          lifeTimes.detached();
        }
      };
    }, []);

    const itemSty = React.useMemo(
      () => ({
        ...(state.itemStyle || {}),
        ...(!showState ? { display: 'none' } : {}),
      }),
      [state.itemStyle, showState]
    );

    const itemClsName = React.useMemo(() => {
      const data = propsRef.current;
      let cls = 'ui-item';
      if (data.itemClass) {
        if (data.itemClass.indexOf('ui-item') === -1) {
          cls = 'ui-item ' + data.itemClass;
        } else {
          cls = data.itemClass;
        }
      }
      data.itemClass = cls;
      propsRef.current = data;
      return cls
    }, [className]);

    const itemInnerComponents = React.useMemo(() => {
      if (!isEmpty(innerCmpts)) {
        return Object.keys(innerCmpts).map((ky: string, ii: number) => {
          const config = innerCmpts[ky];
          return execAtaComponent(ky, config);
        });
      }
    }, [innerCmpts]);
    
    return (
      <div
        className={itemClsName}
        style={itemSty}
        id={props.id}
        // data-uniq-id={uniqId}
        {...events} // 事件
        {...attr}
      >
        {/* {!isArray(state.title)
          ? React.useMemo(
              () => (
                <ItemTitle
                  title={state.title}
                  itemProperties={props}
                  context={context}
                />
              ),
              [state.title]
            )
          : React.useMemo(
              () => (
                <ItemTitle
                  title={state.title}
                  itemProperties={props}
                  context={context}
                />
              ),
              [state.title?.length, state.title]
            )} */}
        <HyperlinkWrap url={props.url}>
          {
            React.useMemo(
              () => (
                <ItemTitle
                  title={state.title}
                  itemProperties={props}
                  context={context}
                />
              ),
              [state.title?.length, state.title]
            )
          }

          {itemInnerComponents}

          {
            React.useMemo(
              () => (
                <ItemBody
                  body={state.body}
                  itemProperties={props}
                  context={context}
                />
              ),
              [state.body?.length, state.body]
            )
          }

          {
            React.useMemo(
              () => (
                <ItemFooter
                  footer={state.footer}
                  itemProperties={props}
                  context={context}
                />
              ),
              [state.footer?.length, state.footer]
            )
          }

          {
            React.useMemo(
              () => (
                <ItemDot
                  dot={state.dot}
                  itemProperties={props}
                  context={context}
                />
              ),
              [state.dot?.length, state.dot]
            )
          }
        </HyperlinkWrap>

        {/* {isArray(state.body)
          ? React.useMemo(
              () => (
                <ItemBody
                  body={state.body}
                  itemProperties={props}
                  context={context}
                />
              ),
              [state.body?.length, state.body]
            )
          : null}

        {isArray(state.footer)
          ? React.useMemo(
              () => (
                <ItemFooter
                  footer={state.footer}
                  itemProperties={props}
                  context={context}
                />
              ),
              [state.footer?.length, state.footer]
            )
          : null}

        {isArray(state.dot)
          ? React.useMemo(
              () => (
                <ItemDot
                  dot={state.dot}
                  itemProperties={props}
                  context={context}
                />
              ),
              [state.dot?.length, state.dot]
            )
          : null} */}
      </div>
    );
  }
);
